/**
 * Transforms text to lowercase depending on opco configuration according to the brand guideline.
 *
 * @link https://brandportal.randstad.com/guidelines/guide/62b8181f-eab2-4765-9581-0d975f77a326/page/3ec3a13d-79fc-4ac0-9d4c-60cbd62b4419
 * @param {String} text
 * @param {Boolean} skipAcronymCheck
 * @returns {String}
 */
export default function textTransform(text, skipAcronymCheck = false) {
  if (typeof text !== 'string') {
    throw new TypeError('Text parameter should be of string type.');
  }

  if (process.env.REACT_APP_USE_LOWER_CASE === 'true') {
    if (!skipAcronymCheck) {
      const acronym = /^[A-Z]*$/;
      // Acronyms has to stay as they are.
      return text.split(' ').map((a) => (acronym.test(a) ? a : a.toLowerCase())).join(' ');
    }

    return text.toLowerCase();
  }
  return text;
}
